import React from 'react'
import { Container } from 'react-responsive-grid'
import Headroom from 'react-headroom'
import HoverLink from './styled/HoverLink'
import { prefixLink } from 'gatsby-helpers'
import { rhythm } from '../utils/typography'
import SquareMenu from '../components/SquareMenu'

export default class ReactComponent extends React.Component {
  render() {
    return(
      <div>
      <Headroom
        wrapperStyle={{
          marginBottom: rhythm(1)
        }}
        style={{
          background: 'white',
          borderBottom: '2px solid lightgray',
          color: 'gray',
          fontFamily: 'Oswald, sans-serif'
        }}
      >
        <Container
          style={{
            display: 'flex',
            maxWidth: 960,
            paddingTop: 0,
            padding: `${rhythm(1)} ${rhythm(3/4)}`,
          }}
        >
          <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center'
            }}>
            <HoverLink
              to={prefixLink('/')}
              style={{
                fontSize: '1.4em',
                textDecoration: 'none'
              }}
              >
              dasProject
            </HoverLink>
            <SquareMenu activeColor={this.props.color} />
            <HoverLink
              to={prefixLink('/about/')}
              style={{
                textDecoration: 'none',
              }}
              >
              About
            </HoverLink>
          </div>
        </Container>
      </Headroom>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../components/Header.js